import styled from 'styled-components';
import breakpoint from '~/utils/style-utils.ts';

const TextWrapper = styled.div`
	max-width: var(--textWidth);
	& a {
		color: rgb(var(--embed-link-color));
		* {
			color: rgb(var(--embed-link-color));
		}
	}
	margin: 12px 12px 24px 12px;
	${breakpoint.lg`
			margin: 0 auto ${props => (props.addMargin ? '48px' : '0')} auto;
		`};
	${breakpoint.lg`
	padding: 0 12px;`}
	* {
		text-transform: none;
	}
`;

export default TextWrapper;
